import { useApp, DeploymentType } from "@/api";
import { useProxyAuthCookie } from "@/hooks/proxyAuthCookie";
import App from "./App";

interface Props {
  appSlug: string;
  organizationSlug: string;
  appPath?: string;
  appSearchParams?: Record<string, unknown>;
}

const OrganizationApp = ({
  appSlug,
  organizationSlug,
  appPath,
  appSearchParams
}: Props) => {
  const { data, loading, error } = useApp({
    appSlug,
    organizationSlug
  });
  const isProxyAuthCookieSet = useProxyAuthCookie();

  return (
    <App
      deploymentId={data?.app?.defaultDeployment?.id || ""}
      deploymentType={DeploymentType.Organization}
      releaseNotesBase64={
        data?.app?.defaultDeployment?.current?.appVersion.releaseNotes
          ?.contentBase64 || undefined
      }
      userGuideBase64={
        data?.app?.defaultDeployment?.current?.appVersion.userGuide
          ?.contentBase64 || undefined
      }
      error={error}
      loading={loading}
      isProxyAuthCookieSet={isProxyAuthCookieSet}
      appPath={appPath}
      appSearchParams={appSearchParams}
    />
  );
};

export default OrganizationApp;
